const admin = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/backstage/backstage.vue')
const adminIndex = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/backstageIndex/backstageIndex.vue')
const doctorlist = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/doctorlist/doctorlist.vue')
const userFormList = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/userFormList/userFormList.vue')
const formStyle = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/formStyle/formStyle.vue')
const salesman = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/salesman/salesman.vue')
const linkCreate = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/linkCreate/linkCreate.vue')


export default [
  {
    path: '/admin',
    name: 'admin',
    component: admin,
    redirect: '/admin/home',
    children: [
      {
        // 后台首页 也是个人中心
        path: 'home',
        name: 'home',
        component: adminIndex
      },
      {
        // 用户信息表单收集
        path: 'userFormList',
        name: 'userFormList',
        component: userFormList
      },
			{
        // 表单样式列表
        path: 'formStyle',
        name: 'formStyle',
        component: formStyle
      },
      {
        // 业务员管理列表
        path: 'salesman',
        name: 'salesman',
        component: salesman
      },
      {
        // 生成链接
        path: 'linkCreate',
        name: 'linkCreate',
        component: linkCreate
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/modules/admin.js